@if (pendingInvitations$$().length > 0) {
    <div class="invitations-notice">
        @for (invitation of pendingInvitations$$(); track invitation[invitationKeys.guid]) {
            <div class="invitations-notice__row">
                <span>
                    Je bent uitgenodigd voor
                    <strong>{{invitation[invitationKeys.domain_Name]}}</strong>
                    @if (invitation[invitationKeys.domain_RequireTwoFactor]) {
                        (dit domain vereist tweestapsverificatie)
                    }
                </span>
                @if (invitation[invitationKeys.status] === invitationStatus.pending) {
                    <app-button-action (btnClick)="invitation_accept(invitation)">accepteer</app-button-action>
                } @else {
                    <span class="invitations-notice__pending">wachtend op goedkeuring</span>
                }
            </div>
        }
    </div>
}

<app-tab-page draggable />

<ng-container>
    <ng-template #template_compact>
        <app-account-compact />
    </ng-template>
    <ng-template #template_details>
        <app-account-details (onPageLoaded)="emit_onPageLoaded()" />
    </ng-template>
    <ng-template #template_edit>
        <app-account-edit
            (onEscape)="emit_onEscape();"
            (onPageLoaded)="emit_onPageLoaded()"
            [autofocus]="true"
        />
    </ng-template>

    <ng-template #template_tab0>
        <app-domain-tablist (onPageLoaded)="emit_onPageLoaded()" />
    </ng-template>
    <ng-template #template_tab1>
        <app-function-member-tablist (onPageLoaded)="emit_onPageLoaded()" />
    </ng-template>
    <ng-template #template_tab2>
        <app-user-photo-tablist [ownerGuid]="_ownGuid$$()" (onPageLoaded)="emit_onPageLoaded()" (onOwnMainPhotoChanged)="emit_ownMainPhotoChanged($event)" />
    </ng-template>

    <ng-template #template_tab3>
        <app-chat-tablist mine (onPageLoaded)="emit_onPageLoaded()" />
    </ng-template>
    <ng-template #template_messages>
        <app-message-tablist [context]="messageListContext.mine" (onPageLoaded)="emit_onPageLoaded()" />
    </ng-template>

    <ng-template #template_footerLeft>
        <app-button-navigation  
            (btnClick)="pageAdmin_goto()"
            [class.invisible]="!btnAdminPanel_show()"
            [tooltip]="'administrator panel'"
        >
            <app-icon name="gear" />
        </app-button-navigation>
    </ng-template>
</ng-container>
